import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  GuardResult,
  MaybeAsync,
  RouterStateSnapshot,
} from '@angular/router';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { User, UserRoleType } from 'BaseDataTypes';
import { UserService } from 'BaseServices/user-service';

@Injectable()
export class authGuard implements CanActivate {
  selectedRole: number = 0;
  siteForIdCheck: number = 0;
  public href: string = '';

  userService = inject(UserService);
  currentUser = this.userService.currentUser;
  router = inject(Router);
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    /*
    this.sharedDataService.selectedRole$.subscribe(roleId => {
    this.selectedRole = roleId;
    });*/
    var idToken = localStorage.getItem('idToken')?.toString();
    this.href = state.url;
    var subject = new Subject<boolean>();
    this.userService
      .validateIdTokenAndLoginUser(idToken!)
      ?.subscribe((result) => {
        if (result) {
          const allowedUserRoleType = route.data['allowedUserRoleType'];

          var CorrectRoleType = this.getCorrectRoleBasedOnUrl(
            this.userService.currentUser!
          );
          if (CorrectRoleType === this.userService.getUserRoleTypes.Admin) {
            var selectedRole = this.userService.getSelectedRole;
            if (
              allowedUserRoleType.includes(selectedRole) ||
              selectedRole === this.userService.getUserRoleTypes.Admin
            ) {
              subject.next(true);
            } else {
              this.router.navigate(['/kursus/unauthorized']);
              subject.next(false);
            }
          } else {
            if (allowedUserRoleType.includes(CorrectRoleType)) {
              subject.next(true);
            } else {
              this.router.navigate(['/kursus/unauthorized']);
              subject.next(false);
            }
          }
        }
      });

    return subject.asObservable();
  }
  /**
   * url decides which roletype
   * @param user
   * @returns
   */
  getCorrectRoleBasedOnUrl(user: User) {
    if (this.href.split('/')[1] == 'kursus') {
      return user.courseRole;
    } else if (this.href.split('/')[1] == 'timelog') {
      return user.timelogRole;
    } else if (this.href.split('/')[1] == 'assets') {
      return user.assetRole;
    } else if (this.href.split('/')[1] == 'udstyr') {
      return user.equipmentRole;
    }
    return UserRoleType.Unauthorized;
  }
}
